import { useEffect, useRef, useState } from "react";

import { request } from "../helpers/request";
import { usePlayerStore } from "../store/usePlayerStore";

import { useSnowplowEnabled } from "./useSnowplowEnabled";

declare const __FINNPANEL_URL: string;

export const useFinnpanelEvent = (): void => {
  const { useStoreState } = usePlayerStore();
  const [spid, setSpid] = useState<string | undefined>(undefined);
  const isPlaybackStarted = useStoreState.isPlaybackStarted();
  const snowplowEnabled = useSnowplowEnabled();
  const finnpanelSent = useRef(false);

  useEffect(() => {
    if (snowplowEnabled) {
      window.yleSnowplow(function () {
        // 'this' refers to the Snowplow context, but it may be undefined
        setSpid(this?.sp1?.getDomainUserId());
      });
    }
  }, [snowplowEnabled]);

  useEffect(() => {
    if (isPlaybackStarted && spid !== undefined && !finnpanelSent.current) {
      const params = { spid };
      request({
        method: "GET",
        parameters: params,
        url: __FINNPANEL_URL,
        useApiKeys: false
      }).catch(err => {
        console.warn("Failed to send request to finnpanel", err);
      });

      finnpanelSent.current = true;
    }
  }, [isPlaybackStarted, spid]);
};
